// Shared chart color palette used by PollingResults charts
export const CHART_COLORS = ["#292fc1", "#44ffff", "#0073b8", "#00c15b", "#f6d645", "#f4293a", "#646464", "#e4e4e4"];

export default CHART_COLORS;
